import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { AppLayout } from '@/components/AppLayout';
import { AppHeader } from '@/components/AppHeader';
import { FullScreenLoader } from '@/components/FullScreenLoader';
import { useApiResource } from '@/hooks/useApiResource';
import { useLang } from '@/context/LanguageContext';
import api from '@/lib/api';
import {
  MainFocusCard, TopPriorities, ActiveGoalsRow, ProjectsAttention,
  FinanceSnapshot, HabitsToday, AINextStep,
} from '@/components/dashboard/DashboardSections';

export default function Dashboard() {
  const navigate = useNavigate();
  const { t, lang } = useLang();
  const { data, loading, reload } = useApiResource(
    () => api.get('/dashboard').then((r) => r.data),
    { errorMessage: t('dashboard.loadError'), deps: [lang] }
  );

  const completeTask = async (task) => {
    try {
      await api.put(`/tasks/${task.id}`, { status: 'Done' });
      toast.success(t('dashboard.taskDone'));
      reload();
    } catch (e) {
      toast.error(t('dashboard.taskError'));
    }
  };

  const toggleHabit = async (habit) => {
    try {
      await api.post(`/habits/${habit.id}/toggle`);
      reload();
    } catch (e) {
      toast.error(t('dashboard.habitError'));
    }
  };

  if (loading || !data) return <FullScreenLoader label={t('dashboard.loader')} />;

  return (
    <AppLayout>
      <AppHeader title={data.greeting} subtitle={data.subGreeting} showMore />
      <div className="mt-3 space-y-5">
        <MainFocusCard mainFocus={data.mainFocus} onStart={() => navigate('/tasks')} />
        <TopPriorities tasks={data.topPriorities} onComplete={completeTask} onSeeAll={() => navigate('/tasks')} />
        <ActiveGoalsRow goals={data.activeGoals} onOpen={() => navigate('/goals')} onSeeAll={() => navigate('/goals')} />
        <ProjectsAttention projects={data.projectsNeedingAttention} onOpen={(p) => navigate(`/projects/${p.id}`)} onSeeAll={() => navigate('/projects')} />
        <FinanceSnapshot fin={data.finance || {}} onOpen={() => navigate('/finance')} />
        <HabitsToday habits={data.habits} onToggle={toggleHabit} onSeeAll={() => navigate('/habits')} />
        <AINextStep text={data.aiNextStep} onAsk={() => navigate('/ai')} />
      </div>
    </AppLayout>
  );
}
